export const ShyHeader = () => ({
  shyOffset: 250,
  shyClass: 'js-shy',
  lastUp: window.pageYOffset,

  init() {
    window.addEventListener("scroll", () =>
      this.scrollListener(window.pageYOffset)
    );
    document.addEventListener("DOMContentLoaded", () =>
      setTimeout(() =>
        this.scrollListener(window.pageYOffset)
      , 500)
    );
  },

  scrollListener(top) {
    if (
      top < this.lastUp ||
      this.$el?.classList.contains("js-menu-open") ||
      document.querySelector("body")?.classList.contains("js-mobile-menu-open")
    ) {
      this.showShy(top);
    } else if (top > this.shyOffset + this.lastUp) {
      this.hideShy(top);
    }
  },

  hideShy(top = window.pageYOffset) {
    document.body.classList.add(this.shyClass);
    this.lastUp = top;
  },

  showShy(top = window.pageYOffset) {
    document.body.classList.remove(this.shyClass);
    this.lastUp = top;
  },
});
